var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ElementRef, HostListener, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractComponent } from 'gp-admin-abstract';
var PhoneInputComponent = /** @class */ (function (_super) {
    __extends(PhoneInputComponent, _super);
    function PhoneInputComponent(el) {
        var _this = _super.call(this, el) || this;
        _this.el = el;
        /**
         * Состояние компонента
         * @type {boolean}
         */
        _this.disabled = false;
        /**
         * Плейсхолдер - для предпросмотра
         * @type {string}
         */
        _this.placeholder = 'Телефон';
        /**
         * Заголовок компонента
         * @type {string}
         */
        _this.title = 'Телефон';
        _this.propagateChange = function (_) {
        };
        return _this;
    }
    PhoneInputComponent.prototype.onKeyDown = function (event) {
        var e = event;
        if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode === 65 && e.ctrlKey === true) ||
            // Allow: Ctrl+C
            (e.keyCode === 67 && e.ctrlKey === true) ||
            // Allow: Ctrl+V
            (e.keyCode === 86 && e.ctrlKey === true) ||
            // Allow: Ctrl+X
            (e.keyCode === 88 && e.ctrlKey === true) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    };
    PhoneInputComponent.prototype.ngOnInit = function () {
        if (this.phone) {
            this.prettyPhone(this.phone);
        }
    };
    PhoneInputComponent.prototype.writeValue = function (value) {
        if (value) {
            this.prettyPhone(value);
        }
        else {
            this.phone = null;
        }
    };
    PhoneInputComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    PhoneInputComponent.prototype.registerOnTouched = function (fn) {
    };
    PhoneInputComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    /**
     * При вводе чисел
     * @param e
     */
    PhoneInputComponent.prototype.onChange = function (e) {
        this.prettyPhone(e);
    };
    /**
     * Преобразование телефона
     * @param phone
     */
    PhoneInputComponent.prototype.prettyPhone = function (phone) {
        phone = phone.replace(/\D/g, '');
        for (var i = 0; i < PhoneInputComponent.PHONE_FORMAT_REGEXP.length; i++) {
            var exp = PhoneInputComponent.PHONE_FORMAT_REGEXP[i].regexp;
            var format = PhoneInputComponent.PHONE_FORMAT_REGEXP[i].format;
            var re = new RegExp(exp);
            if (re.test(phone)) {
                phone = phone.replace(exp, format);
                break;
            }
        }
        this.phone = phone;
        this.propagateChange(this.phone);
    };
    /**
     * Регулярное выражение
     * @type {regexp}
     */
    PhoneInputComponent.PHONE_FORMAT_REGEXP = [
        { regexp: '^(\d)$', format: '+$1' },
        { regexp: '^(\d)(\d{1,3})$', format: '+$1 $2' },
        { regexp: '^(\d)(\d{3})(\d{1,3})$', format: '+$1 $2 $3' },
        { regexp: '^(\d)(\d{3})(\d{3})(\d{1,2})$', format: '+$1 $2 $3-$4' },
        { regexp: '^(\d)(\d{3})(\d{3})(\d{2})(\d{1,2})$', format: '+$1 $2 $3-$4-$5' }
    ];
    PhoneInputComponent.decorators = [
        { type: Component, args: [{
                    selector: 'gp-phone-input',
                    template: "\n<!-- TODO: \u043F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043D\u0430 \u0441\u0442\u0438\u043B\u0438 -->\n<div class=\"gp-phone-input\"\n     [ngClass]=\"{'gp-input--filled': !!phone, 'gp-input--disabled': disabled}\">\n\n  <div class=\"flex flex--content-between\">\n    <div class=\"gp-phone-input__title\">{{ title }}</div>\n    <div class=\"gp-phone-input__error\">{{ error }}</div>\n  </div>\n\n  <input\n    type=\"text\"\n    [name]=\"name\"\n    maxlength=\"16\"\n    class=\"gp-phone-input__area\"\n    [(ngModel)]=\"phone\"\n    (ngModelChange)=\"onChange($event)\"\n    [placeholder]=\"placeholder\"\n    [disabled]=\"disabled\">\n</div>\n",
                    styles: [
                        "@charset \"UTF-8\";\n/**\n * \u041F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0435\n */\n:root {\n  --color-white: white;\n  --color-success: #00afec;\n  --color-warning: #ffb827;\n  --color-error: #f35252;\n  --color-disabled: #dbdbdb;\n  --color-black: black;\n  --color-span: #b5b5b5;\n  --color-span-second: #212121;\n  --color-bg: #f8f8f8;\n  --color-bg-second: #f8f8f8;\n  --color-bg-success: rgba(0, 175, 236, 0.1);\n  --color-bg-warning: var(--color-warning);\n  --color-bg-error: var(--color-error);\n  --color-placeholder: #b5b5b5;\n  --color-border: #dbdbdb;\n  --color-radio-border: #d3d3d3;\n  --font-roboto: 'Roboto', sans-serif;\n  --font-helvetica: 'Helvetica', sans-serif; }\n\n/**\n *\n */\n/**\n * \u0421\u0442\u0438\u043B\u0438 \u0434\u043B\u044F \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0430 \"gp-phone-input\"\n */\n.gp-phone-input--success input.gp-phone-input__area {\n  border-color: #00afec; }\n\n.gp-phone-input--success .gp-phone-input__title {\n  color: #00afec; }\n\n.gp-phone-input--error input.gp-phone-input__area {\n  border-color: #f35252; }\n\n.gp-phone-input--error .gp-phone-input__title {\n  color: #f35252; }\n\n.gp-phone-input--error .gp-phone-input__error {\n  display: block; }\n\n.gp-phone-input--disabled input.gp-phone-input__area {\n  cursor: not-allowed;\n  color: #b5b5b5;\n  border-color: #dbdbdb;\n  background-color: #f8f8f8; }\n\n.gp-phone-input__title {\n  font: 400 1.2rem/1.4rem \"Roboto\", sans-serif;\n  margin-bottom: 0.5rem;\n  color: #b5b5b5; }\n\n.gp-phone-input__error {\n  font: 400 1.2rem/1.4rem \"Roboto\", sans-serif;\n  display: none;\n  color: #f35252; }\n\n.gp-phone-input__area {\n  font: 1.3rem/1.5rem \"Roboto\", sans-serif;\n  width: 100%;\n  padding: 1rem 1.5rem;\n  color: #212121;\n  border: 0.1rem solid #dbdbdb;\n  border-radius: 0.2rem;\n  background-color: #fff; }\n  .gp-phone-input__area[type=\"password\"] {\n    letter-spacing: 0.5rem;\n    font-weight: 900; }\n\n.gp-phone-input input::-webkit-input-placeholder,\n.gp-phone-input input:-ms-input-placeholder,\n.gp-phone-input input::placeholder {\n  color: #b5b5b5; }\n"
                    ],
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return PhoneInputComponent; }),
                            multi: true
                        }
                    ],
                },] },
    ];
    /** @nocollapse */
    PhoneInputComponent.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    PhoneInputComponent.propDecorators = {
        'disabled': [{ type: Input },],
        'name': [{ type: Input },],
        'placeholder': [{ type: Input },],
        'error': [{ type: Input },],
        'title': [{ type: Input },],
        'phone': [{ type: Input },],
        'onKeyDown': [{ type: HostListener, args: ['keydown', ['$event'],] },],
    };
    return PhoneInputComponent;
}(AbstractComponent));
export { PhoneInputComponent };
//# sourceMappingURL=phone-input.component.js.map